const TENANT_TYPE = {
    prospective: 'FUTURE_RESIDENT',
    current: 'CURRENT_RESIDENT',
    former: 'FORMER_RESIDENT'
};


export { TENANT_TYPE };
